__turbopack_context__.v({
  "microReviewCount": "TrustPilot-module__dBOkJq__microReviewCount",
});
